export interface RecalProposalSetDtlEntity {
    id?: number | null,
    tarProposalSetId?: number | null,
    proposalId?: number | null,
    companyCode?: string | null,
    companyType?: string | null,
    proposalNo?: string | null,
    effectiveDate?: Date | null,
    expiryDate?: Date | null,
    createdBy?: string | null,
    createdDateTime?: Date | null,

    [key: string]: string | boolean | null | Object | undefined
}

export const EMPTY_RECAL_PROPOSAL_SET_DTL_ENTITY: RecalProposalSetDtlEntity = {

    id: null,
    tarProposalSetId: null,
    proposalId: null,
    companyCode: null,
    companyType: null,
    proposalNo: null,
    effectiveDate: null,
    expiryDate: null,
    createdBy: null,
    createdDateTime: null,

}